"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _weirDls = require("@weirgroup/weir-dls");
var _mainModule = _interopRequireDefault(require("./main.module.css"));
var _epocConverter = require("../../../../utilities/epocConverter");
var _userdetailsConstants = require("../userdetailsConstants");
var _constants = require("../../constants");
class UserActivity extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getuserListData(props) {
    const dataList = props.userActivity.userActivities;
    const appanme = props.userActivity.applicationName;
    const tableData = {
      tableHeaders: [{
        label: _userdetailsConstants.userDetailsConstants.DATE,
        sortable: true,
        type: 'date',
        key: 'dateVal'
      }, {
        label: _userdetailsConstants.userDetailsConstants.APPLICATION_NAME,
        sortable: true,
        type: 'string',
        key: 'applicationName'
      }, {
        label: _userdetailsConstants.userDetailsConstants.STATUS,
        sortable: true,
        filterable: true,
        type: 'string',
        key: 'status',
        renderFn(data) {
          const isStatusSuccess = (data.status.source || '').toLowerCase().indexOf('success') > -1;
          const isStatusFailure = (data.status.source || '').toLowerCase().indexOf('failure') > -1;
          let colorClass = '';
          if (isStatusSuccess) {
            colorClass = _mainModule.default.success;
          } else if (isStatusFailure) {
            colorClass = _mainModule.default.failed;
          }
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "".concat(colorClass, " ").concat(_mainModule.default.maxWidth)
          }, data.status.value);
        }
      }, {
        label: _userdetailsConstants.userDetailsConstants.LOCATION,
        sortable: true,
        type: 'string',
        key: 'location'
      }, {
        label: _userdetailsConstants.userDetailsConstants.IP_ADDRESS,
        sortable: true,
        type: 'string',
        key: 'ipAddress'
      }],
      data: []
    };
    dataList && dataList.length > 0 && dataList.map(item => {
      tableData.data.push({
        'dateVal': (0, _epocConverter.convertUniqueDateFormat)(item.date),
        'applicationName': appanme,
        'status': item.status,
        'location': item.location || '-',
        'ipAddress': item.ipAddress || '-'
      });
    });
    this.setState(() => ({
      tableHeaders: null,
      tableSrcData: null
    }), () => {
      this.setState({
        tableHeaders: tableData.tableHeaders,
        tableSrcData: tableData.data
      });
    });
    return tableData;
  }
  componentDidMount() {
    this.getuserListData(this.props);
  }
  componentDidUpdate(prevProps) {
    if (this.props.userActivity && prevProps.userActivity && this.props.userActivity.userActivities !== prevProps.userActivity.userActivities) {
      this.getuserListData(this.props);
    }
  }
  render() {
    const {
      tableHeaders,
      tableSrcData
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      "data-test": "manage-data-views-table",
      className: _mainModule.default.wrapper
    }, tableSrcData && /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.paddingTop20
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Table, {
      header: tableHeaders,
      source: tableSrcData,
      searchable: true,
      sortable: true,
      searchPlaceholder: _constants.tableConstants.SEARCH_PLACEHOLDER_ONBLUR,
      title: "".concat(_userdetailsConstants.userDetailsConstants.ACTIVITY_FOR, " : ").concat(this.props.selectedUser.MineSiteUsersEmail ? this.props.selectedUser.MineSiteUsersEmail.source : ''),
      searchPlaceHolderOnBlur: _constants.tableConstants.SEARCH_PLACEHOLDER_ONBLUR,
      searchPlaceHolderOnFocus: _constants.tableConstants.SEARCH_PLACEHOLDER_ONFOCUS,
      noResultsText: _constants.tableConstants.NO_RECORDS_FOUND_LBL,
      searchResultSingle: _constants.tableConstants.RESULTS_LBL_SINGULAR,
      searchResultPlural: _constants.tableConstants.RESULTS_LBL_PLURAL,
      primaryActionBtnTitle: _userdetailsConstants.userDetailsConstants.BUTTON_LABEL.replace('<MineSiteLabelPlural>', this.props.mineSiteLabel.plural),
      onPrimaryActionBtnClick: this.props.addTeamMemberCallback
    }))));
  }
}
const mapDispatchToProps = () => ({});
const mapStateToProps = state => ({
  mineSiteLabel: state.manageYourTeam.mineSiteLabel
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserActivity);